<template>
  <div
    class="message"
    style="height: calc(100vh - 88px); background-color: #fff"
  >
    <div v-if="messageShow">
      <div class="title">留言审核</div>
      <div class="message-header">
        <div class="status">
          <p>状态:</p>
          <el-select v-model="value" placeholder="全部">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="timePick">
          <p>时间:</p>
          <el-date-picker
            v-model="timeValue"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="search">
          <el-input v-model="input" placeholder="请输入姓名搜索"></el-input>
          <el-button @click="search">搜索</el-button>
        </div>
        <div class="common-reply">
          <el-button @click="messageShow = false">常用回复</el-button>
        </div>
      </div>
      <div class="toatl">数量:{{ total }}</div>
      <div class="table">
        <el-table :data="tableData" border style="width: 100%" >
          <el-table-column prop="from_user_name" label="名称" width="120" header-align="center" align="center" >
          </el-table-column>
          <el-table-column prop="create_at" label="时间"  width="120" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.create_at | timeFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="module_name" label="模块" width="160" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.module_name ? scope.row.module_name : "先进典型"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="内容 " width="980" header-align="center" align="left"> </el-table-column>

          <el-table-column prop="status" label="状态" width="120" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.status == 0
                  ? "正常"
                  : scope.row.status == 1
                  ? "已回复"
                  : scope.row.status == 2
                  ? "已撤回"
                  : ""
              }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="operation" label="操作" width="120" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button @click="hfMessage(scope.row)" type="text" v-if="scope.row.status == 1||scope.row.status == 0"
                >回复</el-button
              >
              <el-popconfirm
                :title="'确定撤回该留言吗？'"
                @confirm="chClick(scope.row)"
                v-if="scope.row.status == 1 || scope.row.status == 0"
              >
                <el-button slot="reference" style="color: #409eff" type="text"
                  >撤回</el-button
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paging">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          :page-size="pagination.pageSize"
          :current-page="pagination.page"
        >
        </el-pagination>
      </div>

      <!-- 留言详情界面 -->
      <div class="message-detail">
        <el-dialog
          title="留言详情"
          :visible.sync="detailShow"
          width="30%"
          :before-close="handleClose"
        >
          <div class="dialog-content">
            <div class="content-header">
              <p>{{ userName }}</p>
              <el-input
                v-model="wyContent"
                autosize
                type="textarea"
                resize="none"
                placeholder="请输入内容"
                :disabled="true"
              ></el-input>
            </div>
            <div
              class="content-item"
              v-for="(item, index) in replyList"
              :key="index"
            >
              <div class="item-header">
                <p>回复</p>
                <p>{{ userName }}</p>
              </div>
              <div class="el-input">
                <el-input
                  v-model="item.comment"
                  autosize
                  type="textarea"
                  resize="none"
                  placeholder="请输入内容"
                  :disabled="item.edit"
                ></el-input>
                <div
                  class="edit"
                  @click="editDetail(item)"
                  v-if="item.edit == true"
                >
                  修改
                </div>
                <div
                  class="del"
                  @click="delDetail(item)"
                  v-if="item.edit == true"
                >
                  删除
                </div>
                <div
                  class="edit"
                  @click="confirmtDetail(item)"
                  v-if="item.edit == false"
                >
                  确定
                </div>
                <div
                  class="del"
                  @click="cancelDetail(item)"
                  v-if="item.edit == false"
                >
                  取消
                </div>
              </div>
            </div>
            <div class="content">
              <p>回复</p>
              <el-input
                type="textarea"
                :autosize="{ minRows: 4 }"
                placeholder="请输入内容"
                v-model="textarea"
                resize="none"
              >
              </el-input>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="backMessage">取 消</el-button>
            <el-button type="primary" @click="confirmReply">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <fast-reply v-else @backAudit="backAudit"> </fast-reply>
  </div>
</template>

<script>
import { Message } from "element-ui";
import "@/utils/timeFilter.js";
import { mapGetters } from "vuex";
import fastReply from "@/components/fast-reply/index.vue";
import {
  remarkListApi,
  remarkUpdateApi,
  remarkCreateApi,
  replyApi,
  remarkInfoApi,
  replyDeleteApi,
  replyUpdateApi,
} from "@/api/open";
export default {
  computed: {
    ...mapGetters([
      "administratorHead",
      "administratorName",
      "administratorId",
    ]),
  },
  components: {
    fastReply,
  },
  data() {
    return {
      pagination: {
        page: 1,
        total: 0,
        pageSize: 10,
      },
      edit: true,
      inputHandle: {},
      userName: "" /* 网友姓名 */,
      wyContent: "" /* 网友回复的内容 */,
      replyList: [] /* 后台给网友回复的列表 */,
      textarea: "" /* 留言详情文本域绑定值 */,
      content: "" /* 留言详情绑定值 */,
      messageShow: true,
      detailShow: false,
      total: "" /* 总数 */,
      input: "" /* 姓名搜索绑定值 */,
      hfContent:"",
      tableData: [],
      options: [
        {
          value: "-1",
          label: "全部",
        },
        {
          value: "0",
          label: "正常",
        },
        {
          value: "1",
          label: "已回复",
        },
        {
          value: "2",
          label: "已撤回",
        },
      ],
      value: "",
      timeValue: "" /* 时间选择器绑定值 */,
    };
  },
  methods: {
    // 删除回复
    replyDelete(i) {
      let params = {
        id: i.id,
      };
      replyDeleteApi(params).then((res) => {
        Message({
          message: res.msg,
          type: "success",
          customClass: "mzindex",
        });
        // this.$message.success(res.msg);
        this.remarkInfo();
      });
    },

    // 获取回复详情
    remarkInfo() {
      let params = {
        id: this.inputHandle.id,
      };
      remarkInfoApi(params).then((res) => {
        this.wyContent = res.data.content;
        this.userName = res.data.from_user_name;
        if (res.data.replyList) {
          res.data.replyList.forEach((element) => {
            element.edit = true;
          });
        }
        this.replyList = res.data.replyList;
        console.log(this.replyList);
      });
    },
    // 新增回复
    replay() {
      let params = {
        remark_id: this.inputHandle.id,
        type: 1,
        comment: this.textarea,
        from_user_id: this.administratorId,
        from_user_head: this.administratorHead,
        from_user_name: this.administratorName,
        user_id: 0,
        to_user_id: this.inputHandle.from_user_id,
        to_user_name: this.inputHandle.from_user_name,
        to_user_head: this.inputHandle.from_user_head,
      };
      replyApi(params).then((res) => {
        Message({
          message: res.msg,
          type: "success",
          customClass: "mzindex",
        });
        // this.$message.success(res.msg);
        this.textarea = "";
        this.remarkInfo();
      });
    },

    // 回复内容里的确定按钮
    confirmReply() {
      if (this.textarea) {
        this.replay();
      } else {
        this.detailShow = false;
        this.remarkList();
      }
    },
    // 撤回
    chClick(row) {
      console.log(row);
      let params = {
        id: row.id,
        status: 2,
      };
      remarkUpdateApi(params).then((res) => {
        this.$message.success(res.msg);
        this.remarkList();
      });
    },
    // 搜索
    search() {
      console.log(this.timeValue);
      this.remarkList();
    },
    // //分页选择
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.remarkList();
    },
    handleClose() {
      this.detailShow = false;
      this.remarkList();
    },
    // 获取评论列表方法
    remarkList() {
      let params = {
        keyWord: this.input,
        status: this.value,
        startTime: this.timeValue?this.timefliter1(this.timeValue[0]):"",
        endTime: this.timeValue?this.timefliter1(this.timeValue[1])+86399:"",
        pageNum: this.pagination.page,
        pageSize: this.pagination.pageSize,
      };
      remarkListApi(params).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.pagination.page = res.data.pageNum;
        this.pagination.total = res.data.total;
        this.pagination.pageSize = res.data.pageSize;
      });
    },
    // 修改留言确定
    confirmtDetail(i) {
      if (i.comment == "") {
        Message({
          message: "修改内容不能为空",
          type: "error",
          customClass: "mzindex",
        });
      } else {
        let params = {
          id: i.id,
          comment: i.comment,
        };
        replyUpdateApi(params).then((res) => {
          Message({
            message: res.msg,
            type: "success",
            customClass: "mzindex",
          });
          // this.$message.success(res.msg);
          this.remarkInfo();
          i.edit = true;
        });
      }
    },
    //   删除留言
    delDetail(i) {
      this.replyDelete(i);
    },
    // 取消按钮
    cancelDetail(i) {
      i.comment=this.hfContent
      i.edit = true;
    },
    //   编辑留言
    editDetail(i) {
      this.hfContent=i.comment
      i.edit = false;
      console.log(i.edit);
    },
    // 返回留言审核页面
    backMessage() {
      this.detailShow = false;
      this.remarkList();
    },
    backAudit(i) {
      this.messageShow = i;
    },

    // 回复
    hfMessage(row) {
      console.log(row);
      this.inputHandle = row;
      this.detailShow = true;
      this.remarkInfo();
    },

    // 过滤时间
    timefliter1(time) {
      if (time) {
        let oDate = new Date(time);
        let time1 = oDate.getTime();
        let time2 = time1 / 1000;
        return time2;
      } else return "";
    },
  },
  mounted() {
    this.remarkList();
  },
  activated() {
    this.messageShow = true;
  },
};
</script>

<style lang="scss" scoped>
.message {
  padding: 10px 20px;
  position: relative;
  .title {
    color: rgba(102, 102, 102, 100);
    font-size: 20px;
    margin-bottom: 15px;
  }
  .message-header {
    position: relative;
    display: flex;
    align-items: center;
    .status {
      display: flex;
      align-items: center;
      p {
        font-size: 20px;
        margin-right: 15px;
      }
    }
    .timePick {
      display: flex;
      align-items: center;
      p {
        font-size: 20px;
        margin-left: 15px;
        margin-right: 15px;
      }
    }
    .search {
      display: flex;
      align-items: center;
      .el-input {
        margin-left: 35px;
        margin-right: 25px;
      }
    }
    .common-reply {
      position: absolute;
      right: 40px;
      top: 0;
    }
  }
  .toatl {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
  }
  .paging {
    text-align: right;
    margin-top: 10px;
  }
  .btn {
    margin-bottom: 10px;
  }
  .message-detail {
    .dialog-content {
      .content-header {
        p {
          font-size: 16px;
          margin-bottom: 5px;
        }
      }
      .content-item {
        margin-top: 10px;
        .item-header {
          display: flex;

          p {
            font-size: 16px;
            margin-bottom: 5px;
          }
          p:nth-of-type(2) {
            margin-top: 2px;
            margin-left: 10px;
            font-size: 14px;
          }
        }
      }
      .el-input {
        display: flex;
        align-items: center;
        .edit {
          margin-left: 10px;
          margin-right: 10px;
          font-size: 16px;
          cursor: pointer;
        }
        .del {
          font-size: 16px;
          cursor: pointer;
        }
      }
      .content {
        p {
          margin-top: 40px;
          font-size: 16px;
          margin-bottom: 5px;
        }
      }
    }
    /deep/ .el-textarea {
      width: 400px;
    }
  }
}
</style>
<style>
.mzindex {
  z-index: 9999 !important;
}
</style>